/**
 * Build-time env, read via Vite's `import.meta.env` (populated from the
 * workspace-root `.env` — see `envDir` in vite.config.ts). Mirrors
 * apps/webapp/src/lib/env.ts's pattern for this app's much smaller surface.
 */
export const env = {
  /** Origin only (e.g. http://localhost:3000) — API routes are requested as `${apiBaseUrl}/api/...`. */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
  /**
   * The web app's own origin — the marketing site and the web app deploy
   * under different subdomains in production (web.workingclock.app vs the
   * root), so this is a build-time Vite var baked into the bundle, falling
   * back to the web app's dev port locally.
   */
  appBaseUrl: import.meta.env.VITE_APP_BASE_URL || 'http://localhost:5173',
};

/** Where the primary CTA sends people to create an account. */
export const signupUrl = `${env.appBaseUrl}/register`;

/**
 * Deep link to the web app's "API tokens" tab — the token the MCP server (and
 * the CLI in CI) authenticates with is created there. The settings screen
 * selects its tab from the `tab` query param, and falls back to the first tab
 * if the value is unknown, so this link degrades to plain Settings at worst.
 */
export const apiTokensUrl = `${env.appBaseUrl}/settings?tab=api-tokens`;

/** The iOS app's App Store listing; without a country code Apple picks the visitor's storefront. */
export const appStoreUrl = 'https://apps.apple.com/app/id6791948889';

/** The Android app's Google Play listing. */
export const googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.workingclock.mobile';

/**
 * Where the desktop installers are served from. Same origin as this site:
 * the server mirrors each desktop release there under stable alias names that
 * always point at the latest build, next to the updater's `latest.json`.
 */
export const desktopDownloadsPath = '/downloads/desktop';
